import { SoundsItem } from "../soundItem/SoundsItem";
import dayForestSound from "../../resources/sounds/dayForest.mp3";
import fireplaceSound from "../../resources/sounds/fireplace.mp3";
import nightForestSound from "../../resources/sounds/nightForest.mp3";
import carsSound from "../../resources/sounds/cars.mp3";
import creekSound from "../../resources/sounds/creek.mp3";
import humansSound from "../../resources/sounds/humans.mp3";
import oceanSound from "../../resources/sounds/ocean.mp3";
import rainSound from "../../resources/sounds/rain.mp3";
import stormSound from "../../resources/sounds/storm.mp3";
import dayForestImg from "../../resources/img/dayForest.jpg";
import nightForestImg from "../../resources/img/nightForest.jpg";
import fireplaceImg from "../../resources/img/fireplace.jpg";
import rainImg from "../../resources/img/rain.jpg";
import oceanImg from "../../resources/img/ocean.jpg";
import stormImg from "../../resources/img/storm.jpg";
import carsImg from "../../resources/img/cars.jpg";
import creekImg from "../../resources/img/creek.jpg";
import humansImg from "../../resources/img/humans.jpg";

export const SoundsBlock = () => {
    return (
        <div className="sounds-block">
            <h2 className="sounds-title">Спробуйте змішувати та поєднувати звуки</h2>
            <div className="sounds">
                <SoundsItem id="1" img={dayForestImg} sound={dayForestSound} />
                <SoundsItem id="2" img={nightForestImg} sound={nightForestSound} />
                <SoundsItem id="3" img={fireplaceImg} sound={fireplaceSound} />
                <SoundsItem id="4" img={rainImg} sound={rainSound} />
                <SoundsItem id="5" img={oceanImg} sound={oceanSound} />
                <SoundsItem id="6" img={stormImg} sound={stormSound} />
                <SoundsItem id="7" img={creekImg} sound={creekSound} />
                <SoundsItem id="8" img={humansImg} sound={humansSound} />
                <SoundsItem id="9" img={carsImg} sound={carsSound} />
            </div>
        </div>
    );
}